import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setPageTitle } from 'store/actions/header';
import { GridColumn, GridRow } from 'app/layouts/grid';
import { WebsiteIntegration } from './items/website';
import useScreenSize from 'hooks/size';
import { MobilePushItem } from './items/mobi-push';

export const AllIntegrations = () => {
  const dispatch = useDispatch();
  const { isLargeDesktop } = useScreenSize();

  useEffect(() => {
    dispatch(setPageTitle([{ title: 'Integrations', path: '.' }]));
  }, []);

  return (
    <GridRow num_of_columns={isLargeDesktop ? 4 : 3}>
      <GridColumn>
        <WebsiteIntegration />
      </GridColumn>
      <GridColumn>
        <MobilePushItem />
      </GridColumn>
    </GridRow>
  );
};
